import { render } from "./hosterConfirm.vue?vue&type=template&id=1066bf42&scoped=true&ts=true"
import script from "./hosterConfirm.vue?vue&type=script&lang=ts"
export * from "./hosterConfirm.vue?vue&type=script&lang=ts"

import "./hosterConfirm.vue?vue&type=style&index=0&id=1066bf42&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1066bf42"]])

export default __exports__